import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/VerifyEmail.css';

const VerifyEmail = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const { token } = useParams();
  const navigate = useNavigate();
  const { verifyEmail, resendVerificationEmail } = useAuth();
  const [email, setEmail] = useState('');
  const [isResending, setIsResending] = useState(false);
  const [resendSuccess, setResendSuccess] = useState('');
  const [resendError, setResendError] = useState('');

  // 토큰으로 이메일 인증
  useEffect(() => {
    const verifyUserEmail = async () => {
      if (!token) {
        setIsLoading(false);
        setError('유효하지 않은 인증 링크입니다.');
        return;
      }

      try {
        const result = await verifyEmail(token);
        if (result.success) {
          setIsSuccess(true);
          setMessage(result.message);
        } else {
          setError(result.message);
        }
      } catch (err) {
        setError('이메일 인증 중 오류가 발생했습니다.');
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    verifyUserEmail();
  }, [token]);

  // 인증 이메일 재전송 처리
  const handleResendEmail = async (e) => {
    e.preventDefault();
    setIsResending(true);
    setResendSuccess('');
    setResendError('');

    if (!email) {
      setResendError('이메일을 입력해주세요.');
      setIsResending(false);
      return;
    }

    // 이메일 유효성 검증
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
      setResendError('유효한 이메일 주소를 입력해주세요.');
      setIsResending(false);
      return;
    }

    try {
      const result = await resendVerificationEmail(email);
      if (result.success) {
        setResendSuccess(result.message);
      } else {
        setResendError(result.message);
      }
    } catch (err) {
      setResendError('인증 이메일 재전송 중 오류가 발생했습니다.');
      console.error(err);
    } finally {
      setIsResending(false);
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  return (
    <div className="verify-email-container">
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <div className="loading-text">이메일 인증 중입니다...</div>
        </div>
      )}
      <div className="verify-email-form-container">
        <h2>이메일 인증</h2>
        
        {isLoading ? (
          <div className="loading-spinner-container">
            <p>이메일 인증 중입니다...</p>
          </div>
        ) : isSuccess ? (
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h3>인증 완료!</h3>
            <p>{message}</p>
            <Link to="/login" className="btn btn-primary">
              로그인 페이지로 이동
            </Link>
          </div>
        ) : (
          <div className="error-message">
            <div className="error-icon">!</div>
            <h3>인증 실패</h3>
            <p>{error}</p>
            
            <div className="resend-form">
              <h4>인증 이메일 재전송</h4>
              <p>인증 이메일을 다시 받으시려면 이메일 주소를 입력해주세요.</p>
              
              {resendSuccess && <div className="alert alert-success">{resendSuccess}</div>}
              {resendError && <div className="alert alert-danger">{resendError}</div>}
              
              <form onSubmit={handleResendEmail}>
                <div className="form-group">
                  <label htmlFor="email">이메일</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={email}
                    onChange={handleEmailChange}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary" disabled={isResending}>
                  {isResending ? '전송 중...' : '인증 이메일 재전송'}
                </button>
              </form>
            </div>
            
            <div className="verify-email-links">
              <Link to="/login">로그인 페이지로 돌아가기</Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail; 